import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui-helpers";
import { MessagesSquare } from "lucide-react";

// Team messages linked to a client or case (read-only view; conversations live in Messages).
export function TeamLinkedMessages({ clientId, applicationId }) {
  const [msgs, setMsgs] = useState(null);
  useEffect(() => {
    api.get("/team/linked", { params: applicationId ? { application_id: applicationId } : { client_id: clientId } })
      .then((r) => setMsgs(r.data)).catch(() => setMsgs([]));
  }, [clientId, applicationId]);
  if (msgs === null) return null;
  return (
    <Card className="p-5" data-testid="team-linked-messages">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-head font-bold text-slate-900 inline-flex items-center gap-2"><MessagesSquare className="h-4 w-4 text-primary" /> Team discussion</h3>
        <Link to="/admin/messages" className="text-xs font-semibold text-primary">Open Messages</Link>
      </div>
      {msgs.length === 0 ? <p className="text-sm text-slate-400">No team messages linked yet. In Messages, use the link button to attach a message to this {applicationId ? "case" : "client"}.</p> : (
        <div className="space-y-2 max-h-80 overflow-y-auto">
          {msgs.map((m) => (
            <Link key={m.id} to={`/admin/messages?c=${m.channel_id}`} data-testid={`team-linked-${m.id}`} className="block bg-slate-50 hover:bg-slate-100 rounded-lg px-3 py-2">
              <div className="text-[11px] text-slate-400"><b className="text-slate-700">{m.sender_name}</b> in {m.channel_name} · {(m.created_at || "").slice(0, 16).replace("T", " ")}{!applicationId && m.app_number ? ` · ${m.app_number}` : ""}</div>
              <div className="text-sm text-slate-700 line-clamp-2">{m.body}</div>
            </Link>
          ))}
        </div>
      )}
    </Card>
  );
}
